export default __webpack_public_path__ + "08f92baa4a3bb822196922320baf74e2.png";